<template>
  <div class="ip-auth-page">
    <IpAuthModal 
      @auth-success="handleAuthSuccess"
      @auth-failed="handleAuthFailed"
    />
  </div>
</template>

<script>
import IpAuthModal from './IpAuthModal.vue'

export default {
  name: 'IpAuthPage',
  components: {
    IpAuthModal
  },
  // 直接使用组件事件，不需要重复监听服务事件
  methods: {
    // 验证成功处理
    handleAuthSuccess() {
      this.$router.push('/main')
    },
    
    // 验证失败处理
    handleAuthFailed(data) {
      // 验证失败时停留在当前页面，由IpAuthModal组件显示错误信息
    }
  }
}
</script>

<style scoped>
.ip-auth-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/IpAuthPage.vue